module.exports = __webpack_public_path__ + "static/smile-smock-b000a473b7f6e22d60b830247c8b7828.jpg";